import { Directive, Input, inject } from "@angular/core";
import { AbstractControl, NG_VALIDATORS, ValidationErrors } from "@angular/forms";
import { DatepickerComponent } from "~app/common/components/datepicker/datepicker.component";
import { DateUnionType } from "~app/common/utils/date-utils";
import { DateValidators } from "../validators/date-validators";

@Directive({
    selector: "rask-datepicker[raskMaxDate]",
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: MaxDateDirective,
            multi: true
        }
    ]
})
export class MaxDateDirective {
    private readonly datePicker = inject(DatepickerComponent);

    private _raskMaxDate: DateUnionType = null;

    constructor() {
        this.datePicker.allowInvalidInput = true;
    }

    @Input()
    set raskMaxDate(value: DateUnionType) {
        this._raskMaxDate = value;
        this.datePicker.maxDate = value;
    }

    validate(control: AbstractControl<any, any>): ValidationErrors {
        return DateValidators.maxDate(this._raskMaxDate)(control);
    }
}
